/** Filas visibles antes de "Ver más". */
export const SCHEDULE_PREVIEW_COUNT = 6;

export function readScheduleDate(row = {}) {
  return String(row.period || '');
}

export function readSchedulePayment(row = {}) {
  if (row.payment == null || row.payment === '') return null;
  return row.payment;
}
